import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import QRcode from "../../assets/unnamed.png";

export const MeetingQR = ({ meetingCode }) => {
  const [show, setShow] = useState(false);

  const handleOpen = (e) => {
    e.stopPropagation();
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <>

      <div
        style={{ cursor: "pointer", display: "inline-block" }}
        onClick={handleOpen}
      >
        <img
          src={QRcode}
          className="img-fluid"
          style={{ width: "35px", height: "35px", filter: "invert(1)", cursor:"pointer" }}
          alt="QR Icon"
        />
      </div>

      {/* Modal */}
      <Modal show={show} onHide={handleClose} centered size="sm">
        <Modal.Body
          style={{
            padding: "20px 30px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <QRCodeCanvas value={btoa(meetingCode)} size={200} />
          
          
          <p style={{ marginTop: "15px", fontSize: "14px", color: "#555" }}>
            Scan the QR code to join the meeting
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};